// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit';
import { decode } from 'jwt-check-expiry';
import { getProject } from 'utils/common';

// ** UseJWT import to get config
//import useJwt from '@src/auth/jwt/useJwt'

import { OTPLoginType, sessionConfig, userRoleList, ipRoleList, wcRoleList } from 'utils/constant';
//const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.localStorage.getItem(sessionConfig.userData);
  const accessToken = window.localStorage.getItem(sessionConfig.storageTokenKeyName);
  //** Parse stored json or if none return initialValue
  const decode_token = accessToken ? decode(JSON.parse(accessToken)) : null;

  return item && decode_token
    ? {
        userid: decode_token.payload.userid,
        Permission: decode_token.payload.Permission,
        ...JSON.parse(item).userData
      }
    : {};
};

const checkCreatePermission = (permission, roleList) => {
  if (typeof permission === 'string') {
    return roleList?.includes(permission);
  } else {
    return permission?.some((role) => roleList.includes(role));
  }
};

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser(),
    notiMethod: OTPLoginType.EMAIL,
    project: getProject()
  },
  reducers: {
    handleLogin: (state, action) => {
      const accessToken = action.payload?.accessToken;
      const decode_token = accessToken ? decode(accessToken) : null;

      state.userData = {
        userid: decode_token?.payload.userid,
        Permission: decode_token?.payload.Permission,
        ...action.payload.userData
      };

      state[sessionConfig.storageTokenKeyName] = action.payload[sessionConfig.storageTokenKeyName];
      state[sessionConfig.storageRefreshTokenKeyName] = action.payload[sessionConfig.storageRefreshTokenKeyName];
      localStorage.setItem(sessionConfig.userData, JSON.stringify(action.payload.userData));
      localStorage.setItem(sessionConfig.storageTokenKeyName, JSON.stringify(action.payload.accessToken));
      localStorage.setItem(sessionConfig.storageRefreshTokenKeyName, JSON.stringify(action.payload.refreshToken));
    },

    removeProject: (state) => {
      state.project = {};
      localStorage.removeItem(sessionConfig.project);
    },
    handleLogout: (state) => {
      state.userData = {};
      state.project = {};
      state[sessionConfig.storageTokenKeyName] = null;
      state[sessionConfig.storageRefreshTokenKeyName] = null;
      // session keys only — keep lang/theme prefs
      localStorage.removeItem(sessionConfig.userData);
      localStorage.removeItem(sessionConfig.storageTokenKeyName);
      localStorage.removeItem(sessionConfig.storageRefreshTokenKeyName);
      localStorage.removeItem(sessionConfig.project);
      localStorage.removeItem(sessionConfig.product);
      localStorage.removeItem(sessionConfig.products);
      localStorage.removeItem(sessionConfig.IpGuid);
      localStorage.removeItem(sessionConfig.WcGuid);
    },
    setState: (state, action) => {
      const [key, value] = action.payload;
      state[key] = value;
    }
  }
});

export const getCanCreateInIpSection = (state) => {
  const permission = state.auth?.userData?.Permission;
  return checkCreatePermission(permission, ipRoleList);
};
export const getCanCreateInUserSection = (state) => {
  const permission = state.auth?.userData?.Permission;
  return checkCreatePermission(permission, userRoleList);
};

export const getCanCreateInWcSection = (state) => {
  const permission = state.auth?.userData?.Permission;
  return checkCreatePermission(permission, wcRoleList);
};

export const getUserId = (state) => state.auth?.userData?.userid;
export const getNotiMethod = (state) => state.auth?.notiMethod;

export const { removeProject, handleLogin, handleLogout, setState } = authSlice.actions;

export default authSlice.reducer;
